import React from 'react';

import { LabelSuffix, LabelWrapper } from './styles';

export interface LabelProps {
    content: string;
    fontWeight?: number;
    suffix?: string;
}

export function Label({ content, fontWeight, suffix }: LabelProps) {
    return (
        <>
            <LabelWrapper $fontWeight={fontWeight}>{content}</LabelWrapper>
            {suffix && <LabelSuffix>{suffix}</LabelSuffix>}
        </>
    );
}
